/** @jsx jsx */
import { FC } from "react";
import { jsx } from "theme-ui";

import { TimeReport } from "@/data/time-reports";
import { RelatedEntitiesTabs } from "@/views/related";

interface TimeReportDetailsRelatedTabProps {
  timeReport: TimeReport;
}

export const TimeReportDetailsRelatedTab: FC<TimeReportDetailsRelatedTabProps> = ({ timeReport }) => {
  return (
    <RelatedEntitiesTabs
      relatedEntities={timeReport.relatedEntities}
      entityType="time-report"
      entityId={timeReport.guid}
    />
  );
};
